/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import axios from "axios";
import App from "./App.vue";

//plugins
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueAxios from "vue-axios";
import VueMeta from 'vue-meta';
import VueCurrencyFilter from "vue-currency-filter";
import VueDateFns from "vue-date-fns";

// router&store setup
import router from "./router";
import store from "./store";

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(VueMeta, { keyName: 'head' });
Vue.use(VueCurrencyFilter, [
  {
    symbol : '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
  },
  {
    name: 'currency_2',
    symbol : '$',
    thousandsSeparator: ',',
    fractionCount: 0,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
   }
]);
Vue.use(VueDateFns);

// Vue Filters
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
});


axios.interceptors.response.use(function(response) {
  if (!process.env.VUE_APP_VERSION) {
    window.localStorage.setItem('version-update-needed', 'true');
  }

  if (response.headers['x-version'] > process.env.VUE_APP_VERSION) { // if server version newer
    window.localStorage.setItem('version-update-needed', 'true'); // set version update item so can refresh app later
  };

  return response; // continue with response
});

const app = new Vue({
  router: router,
  store: store,
  el: "#app",
  render: h => h(App)
});

store.$app = app;
